import FormBlock from './FormBlock';
import styles from './Skeleton.module.scss';

type Props = {
  amountOfSections?: number;
};

const Skeleton = (props: Props) => {
  const amountOfSections = props.amountOfSections ?? 1;

  return (
    <FormBlock>
      {Array.from({ length: amountOfSections }).map((_, sectionIndex) => (
        <div key={sectionIndex} className={styles.section}>
          <div className={styles.title}></div>
          {Array.from({ length: 3 }).map((__, rowIndex) => (
            <div key={rowIndex} className={styles.row}>
              <div className={styles.label}></div>
              <div className={styles.input}></div>
            </div>
          ))}
        </div>
      ))}
    </FormBlock>
  );
};

export default Skeleton;
